export let Markets = /*#__PURE__*/function (Markets) {
  Markets["CN"] = "cn";
  return Markets;
}({});
export const getQuickBuyColor = ({
  tenant,
  disabled,
  theme
}) => {
  if (disabled) {
    return theme.palette.action.disabled;
  }
  return tenant === Markets.CN ? theme.palette.superApp.main : theme.palette.text.primary;
};
//# sourceMappingURL=helpers.js.map